import { formatDate } from '../../utils';

const transformDeviceId = ({ results = [] }) =>
  results.map(
    ({
      id,
      identifier,
      patientId,
      customerReferenceIdentifier,
      orderIdentifier,
      deviceName,
      type,
      manufacturer,
      status,
      modelNumber,
      withingsStatus,
      createdAt,
      updatedAt,
    }) => ({
      id,
      identifier,
      patientId,
      customerReferenceIdentifier,
      orderIdentifier,
      deviceName,
      type,
      manufacturer,
      status,
      modelNumber,
      withingsStatus,
      createdOn: formatDate(createdAt),
      updatedOn: formatDate(updatedAt),
    }),
  );

export default transformDeviceId;
